import {EpLayer} from "./layer";
import {Style} from "ol/style";
import {LayerControl} from "./LayerControl";
import TileLayer from "ol/layer/Tile";
import {TileWMS} from "ol/source";

export class EpBdlLayer extends EpLayer {
    constructor(map) {
        super(map);

        this.title = 'Bank danych o lasach';
        this.name = 'bdl'

        return this;
    }

    getSource() {
        if(this.source) {
            return this.source;
        }

        return this.generateSource();
    }

    generateSource() {
        return new TileWMS({
            url: 'https://mapserver.bdl.lasy.gov.pl/ArcGIS/services/WMS_BDL/mapserver/WMSServer?',
            params: {
                'LAYERS': this.getLayers().join(','),
                'STYLES': '',
                'TILED': true
            },
        });
    }

    getLayers() {
        let layers = []
        for(let i = 0; i<7; i++) {
            if (LayerControl.getLayerSavedVisibility(`bdl-${i}`) === 'true') {
                layers = [...layers, i]
            }
        }

        return layers;
    }

    /**
     * @returns {VectorLayer<VectorSourceType>}
     */
    getLayer() {
        if (!this.style) {
            this.style = new Style();
        }

        if (!this.layer) {
            let visible = (LayerControl.getLayerSavedVisibility(this.name) ?? 'true') === 'true';

            this.layer = new TileLayer({
                source: this.getSource(),
                style: this.style,
                visible,
                opacity: 0.4
            });
        }

        return this.layer;
    }

    reload() {
        this.layer.setSource(this.generateSource());
    }
}
